export default __webpack_public_path__ + "media/images/mailer/icon_reply-6e85ea232ff199711ff968c0258b7799.png";